<div class="relative" *transloco="let t; read: 'auth.recoverPassword'">
  <div [ngClass]="{ 'blur-md': isLoading }">
    <h3 class="pb-[100px] text-center">{{ t('questionTitle') }}</h3>
    <form [formGroup]="passwordForgottenForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4 pb-[100px]">
        <app-form-element [label]="t('form.email.label')" [labelFor]="'email'" [showRequiredAsterisk]="false">
          <input
            class="form-control"
            id="email"
            type="email"
            autocapitalize="off"
            autocorrect="off"
            [placeholder]="t('form.email.placeholder')"
            formControlName="email"
          />
        </app-form-element>
      </div>
      <div class="grid grid-cols-2 gap-6">
        @if (showBackButton) {
          <button routerLink="/auth/login" type="button" class="btn btn-secondary w-full justify-center">
            {{ t('button.back') }}
          </button>
        }
        <button 
          type="submit" 
          [disabled]="isLoading || passwordForgottenForm.invalid" 
          class="btn btn-primary w-full justify-center"
          [ngClass]="{ 'col-span-2': !showBackButton }"
        >
          {{ t('button.recoverPassword') }}
        </button>
      </div>
    </form>
  </div>
  @if (isLoading) {
    <div class="absolute top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
      <app-loader color="blue"></app-loader>
    </div>
  }
</div>